import React, { Component } from 'react'
import CheckLoginStatus from '../../conditions/CheckLoginStatus'
import WithPatient from '../../conditions/WithPatient'
import ScreeningSessionLayout from '../../layouts/ScreeningSessionLayout'
import ScreeningContent from './ScreeningContent'

export default class Learn extends Component {
  render() {
    const { match } = this.props
    const { patientID } = match.params

    return (
      <CheckLoginStatus loggedOutRedirect="/">
        <WithPatient patientID={patientID}>
          <ScreeningSessionLayout title="titles.screening">
            <ScreeningContent />
          </ScreeningSessionLayout>
        </WithPatient>
      </CheckLoginStatus>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/Screening/index.js